export const FOODTYPE = {
  breakFast: "Desayuno",
  lunch: "Almuerzo",
};